import { type EditorPlugin } from '../../types/aha-editor';
import LabelPillComponent from './components/LabelPillComponent';
import tools from '../../tools';
import LabelPillSchemaPlugin from './LabelPillSchemaPlugin';

export const LabelPillComponentPlugin: EditorPlugin = {
  name: 'Label pill component plugin',
  components: [
    {
      type: 'pill',
      component: LabelPillComponent,
      toolbarItems: [
        [
          tools.ToolLabelPillColorGray,
          tools.ToolLabelPillColorBlue,
          tools.ToolLabelPillColorGreen,
          tools.ToolLabelPillColorYellow,
          tools.ToolLabelPillColorRed,
        ],
        [tools.ToolDelete],
      ],
    },
  ],
};

const LabelPillPlugin = [LabelPillSchemaPlugin, LabelPillComponentPlugin];

export default LabelPillPlugin;
